import { SectionName } from "../types/shop-info.type";

export const DEFAULT_SECTIONS_TO_DISPLAY: Set<SectionName> =
    new Set<SectionName>(["streetAddress1", "phoneNumber", "openingHours"]);
